<template>
    <div>
        <div class="pointer-cursor d-flex align-items-center" @click="showInviteModal = true">
            <h2 class="h6 mt-2 mr-2">{{ $t('users.invite_button') }}</h2>

            <button class="btn btn-secondary btn-sm rounded-circle btn-icon-only">
                <icon name="plus"></icon>
            </button>
        </div>

        <FullscreenLoading v-if="isLoading" />

        <Modal :show="showInviteModal" @close="showInviteModal = false" :custom_modal_class="'modal-xs fullwidth-modal'">
            <div slot="header">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('users.invite_title') }}</h5>
                    <button type="button" class="close" @click="showInviteModal = false" aria-label="Close"><span aria-hidden="true">×</span></button>
                </div>
            </div>

            <div slot="body" class="text-left">
                <UserInviteForm
                    v-if="showInviteModal"
                    @submit="inviteUser"
                    form-id="userInviteForm"
                    :is-loading="isLoading"
                    :errors="formErrors"
                />
            </div>

            <div slot="footer" class="w-100">
                <button type="button" class="btn btn-secondary btn-sm float-left" data-dismiss="modal" @click="showInviteModal = false" :disabled="isLoading">{{ $t('general.close') }}</button>
                <button type="submit" form="userInviteForm" class="btn btn-primary btn-sm float-right" data-dismiss="modal" :disabled="isLoading">{{ $t('users.invite_confirm') }}</button>
            </div>
        </Modal>
    </div>
</template>
<script setup>

    import Modal from '../Modal.vue';
    import { ref } from 'vue';
    import UserInviteForm from '../../forms/users/UserInviteForm.vue';
    import { UserService } from '../../services/userService';
    import { notifyError, notifySuccess } from '../../utils/notify';
    import i18n from '../../utils/locale';
    import FullscreenLoading from '../FullscreenLoading.vue';

    const showInviteModal = ref(false);
    const isLoading = ref(false);
    const formErrors = ref(null);

    async function inviteUser(data) {
        isLoading.value = true;

        try {
            await UserService.getInstance().inviteUser(data.email, data.role);
            notifySuccess(i18n.t('users.invite_sent'));

            showInviteModal.value = false;
        } catch (exception) {
            formErrors.value = exception?.response?.data?.errors || {
                email: [i18n.t('general.something_went_wrong')],
            };

            notifyError(exception);
        } finally {
            isLoading.value = false;
        }
    }
</script>
